import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalRelacaoDocumentos } from '@/features/relatorio/page/fiscal/relacao-documentos/RelatorioFiscalRelacaoDocumentos';

export const Route = createFileRoute('/a/relatorio/fiscal/relacao-documentos')({
    component: RelatorioFiscalRelacaoDocumentos,
});
